export const RELATION_TYPE_TOKENS = {
    one_to_one: '>',
    one_to_many: '>*',
    many_to_one: '*>',
    many_to_many: '*>*'
}

export function invertRelationType(relType = '') {
    if (relType === 'one_to_many') return 'many_to_one'
    if (relType === 'many_to_one') return 'one_to_many'
    if (relType === 'many_to_many') return 'many_to_many'
    return 'one_to_one'
}

export function relationTypeToToken(relType = '') {
    return RELATION_TYPE_TOKENS[relType] || RELATION_TYPE_TOKENS.one_to_one
}

export function tokenToRelationType(token = '') {
    return Object.entries(RELATION_TYPE_TOKENS).find(([, value]) => value === token)?.[0] || null
}
